import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cee3b5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex wp1200"
}
const _hoisted_2 = { class: "info-panel" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-column gap-2 pt-8 w-full align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/routePlanner/routeLoading.svg",
  alt: "",
  class: "w-5rem mb-2"
}, null, -1))
const _hoisted_5 = { class: "font-semibold text-xl" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-column gap-2 pt-8 w-full align-items-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/routePlanner/routeNotFound.svg",
  alt: "",
  class: "w-5rem mb-2"
}, null, -1))
const _hoisted_8 = { class: "font-semibold text-xl" }
const _hoisted_9 = {
  key: 2,
  class: "flex flex-column w-full pt-4 gap-2"
}
const _hoisted_10 = { class: "flex flex-column w-full gap-2 mt-3" }
const _hoisted_11 = { class: "font-semibold text-2xl" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-column w-full gap-2 border-round-xl border-1 border-300 py-4"
}
const _hoisted_13 = { class: "flex flex-column w-full gap-2" }
const _hoisted_14 = { class: "map hidden lg:block" }
const _hoisted_15 = { class: "map-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeatherAlert = _resolveComponent("WeatherAlert")!
  const _component_GreenRouteCards = _resolveComponent("GreenRouteCards")!
  const _component_IconAdjustmentsAlt = _resolveComponent("IconAdjustmentsAlt")!
  const _component_IconChevronRight = _resolveComponent("IconChevronRight")!
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")!
  const _component_ModeFilter = _resolveComponent("ModeFilter")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_EmissionFilter = _resolveComponent("EmissionFilter")!
  const _component_EffortFilter = _resolveComponent("EffortFilter")!
  const _component_RouteCard = _resolveComponent("RouteCard")!
  const _component_Map = _resolveComponent("Map")!

  return (_ctx.hasRouteQuery)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isLoading && !_ctx.journey)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("route_planner.searching_text")), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("route_planner.searching_subtext")), 1)
              ]))
            : (
          !_ctx.isLoading && (!_ctx.journey || Object.keys(_ctx.journey).length === 0)
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("route_planner.no_routes_text")), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("route_planner.no_routes_subtext")), 1)
                ]))
              : _createCommentVNode("", true),
          (_ctx.hasJourney)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.journey)
                  ? (_openBlock(), _createBlock(_component_WeatherAlert, {
                      key: 0,
                      "weather-forecast": _ctx.journey.weatherForecast
                    }, null, 8, ["weather-forecast"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.journey)
                    ? (_openBlock(), _createBlock(_component_GreenRouteCards, {
                        key: 0,
                        journey: _ctx.journey
                      }, null, 8, ["journey"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "plainButton flex gap-2 align-items-end cursor-pointer py-3 px-0",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFilterOpen = !_ctx.isFilterOpen))
                  }, [
                    _createVNode(_component_IconAdjustmentsAlt, { class: "thin-icon text-2xl text-primary" }),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("route_planner.filter")), 1),
                    (!_ctx.isFilterOpen)
                      ? (_openBlock(), _createBlock(_component_IconChevronRight, {
                          key: 0,
                          class: "ml-auto"
                        }))
                      : (_openBlock(), _createBlock(_component_IconChevronDown, {
                          key: 1,
                          class: "ml-auto"
                        }))
                  ])
                ]),
                (_ctx.isFilterOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_ModeFilter, {
                        modelValue: _ctx.selectedMode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMode) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Divider),
                      _createVNode(_component_EmissionFilter, {
                        modelValue: _ctx.selectedEmission,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedEmission) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Divider),
                      _createVNode(_component_EffortFilter, {
                        modelValue: _ctx.selectedEffort,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedEffort) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Divider),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRoutes, (route, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createVNode(_component_RouteCard, { route: route }, null, 8, ["route"]),
                      _createVNode(_component_Divider)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Map, {
              center: _ctx.center,
              onCenterChanged: _ctx.updateCenter,
              onZoomChanged: _ctx.updateZoom,
              markers: _ctx.routeMarkers,
              "fit-markers": true
            }, null, 8, ["center", "onCenterChanged", "onZoomChanged", "markers"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}